import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Angular Material before v15 always started calendar weeks on Sunday. Newer versions follow the
 * locale (Monday for `en-GB`), so the old behaviour is pinned here to keep the date pickers
 * looking the same.
 */
@Injectable()
export class SundayFirstDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 0;
  }
}
